import template from './parametros.html';
import { FormActions } from 'core/services/form';
import parametrosI18N from 'i18n/parametros/es.json';
import { formatErrorMessage } from 'core/util';

export let ParametrosComponent = {
  templateUrl: template,
  selector: 'parametros',
  bindings: {
    translations: '='
  },
  controller: ParametrosCtrl,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(parametrosI18N);

ParametrosCtrl.$inject = ['BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter'];

function ParametrosCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter) {
  Object.assign(this, { $state, $ngRedux, ngNotify });
  BasicFactory.setup('parametros');
  const parametrosQuery = Filter.path('tipo.codigo').eq('modulo');
  const parametrosUrl = encodeURI('valores?filter=' + JSON.stringify(parametrosQuery));
  const defaultColumnOrder = ['modulo.value', 'descripcion', 'valor.value'];

  this.options = {
    resource: 'parametros',
    hideHeader: true,
    hasOptions: true,
    title: 'Listado de parámetros',
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      {
        data: 'modulo.value',
        title: this.translations['Módulo'],
        type: 'combo',
        filterUrl: parametrosUrl,
        idField: 'value',
        textField: 'value',
        keyData: 'data'
      },
      { data: 'descripcion', title: this.translations['Descripción'] },
      { data: 'valor.value', title: this.translations['Valor'] }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onView: onView.bind(this),
    canRemoveCondition: () => false
  };
  this.mapStateToThis = mapStateToThis.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de parámetros']
    };
    this.form();
  };
  this.gotoForm = gotoForm.bind(this);


  function mapStateToThis(state) {

    if (state.form.removed) {
      this.ngNotify.set('Elemento borrado correctamente', 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    return { form: state.form };
  }

  function gotoForm() {
    this.$state.go('home.parametros.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.parametros.uid.edit', { uid: itemId });
  }

  function onView(itemId) {
    this.$state.go('home.parametros.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/parametros/list/parametros.component.js